import * as React from 'react';
import {Component} from 'react';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {withUpdate} from '../../../../components/Common/HOC/withUpdate';
import {MenuIcon} from './MenuIcon';
import {SearchesDropdown} from '../../../Searches/components/SearchesDropdown';
import {hoverBtns} from '../../../Searches/consts/enums';
import {observer} from 'mobx-react';
import {selectFormSearch} from '../../../Searches/actions/searchesList';
import {renderGeneratorNewState} from '../../../Searches/renderGenerator';
import {Icon, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import {withTooltip} from '../../../../components/Common/HOC/Custom/withTooltip';
import {isPainted} from '../../../../_shared/GWTBridge/invoke/netForm';
import {PageSettings} from './PageSettings';
import {formsStore} from '../../../Form/stores/FormsStore';
import {PrintLabelButtonWithTooltip} from '../../../../components/Common/FormLabel/components/QuickPrintButton';
import {HeaderHelpButton} from '../../../../_shared/Help/components/FormHelpUI';
import {CHANGE_IS_PAINTED, EXIT_FORM} from '../../consts/headerConsts';
import {AutomationRuleBridge} from '../../../../features/Automations/components/bridgeWrap';

@observer
class TopMenuComp extends Component<
    {
        topMenu;
        extraMarkup?;
        searchButton?;
        setUpdateFunc;
        isRTL;
        searchesStore;
        selectedSearch;
        funcs;
        currentForm;
        isReconView;
    },
    any
> {
    constructor(props) {
        super(props);
        this.state = {updates: false};
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({updates: !this.state.updates});
    }

    render() {
        const {topMenu, isRTL, searchesStore, extraMarkup, searchButton, currentForm, isReconView} =
            this.props;
        const {
            excelButton,
            closeButton,
            favoritesButton,
            filtersButton,
            displayButton,
            pageSettings
        } = topMenu;

        /** TODO: we need to handle this issue in a more generic way */
        const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
        return (
            <section className="upper-menu">
                {searchButton}
                {searchesStore && (
                    <SearchesDropdown
                        selectedSearch={searchesStore.formSelected}
                        searchesStore={searchesStore}
                        onSelect={selectFormSearch}
                        displayFiltersCounter={true}
                        openingSide="rightSide"
                        hoverBtnsArr={[hoverBtns.Default, hoverBtns.Edit, hoverBtns.Delete]}
                        onButtonClick={() => renderGeneratorNewState()}
                    />
                )}
                <Separator align="horizontal" height={20} />

                <AutomationRuleBridge
                    automationMenu={topMenu?.automationMenu}
                    componentClasses="spase-x-sm"
                />

                <Separator align="horizontal" height={20} />
                {!isReconView && formsStore?.currentForm?.showPrintLabels && (
                    <PrintLabelButtonWithTooltip
                        tooltip={getLocalizedText(texts.printLabelTooltip)}
                    />
                )}
                <div className="buttons-row">
                    {!extraMarkup && displayButton && (
                        <IconWithTooltip
                            skin="primary"
                            icon={
                                currentForm &&
                                (isPainted(currentForm.table)
                                    ? PriorityIcon.tableView
                                    : PriorityIcon.recordView)
                            }
                            tooltip={displayButton && displayButton.tooltip}
                            onClick={displayButton && displayButton.action}
                            role={CHANGE_IS_PAINTED}
                        />
                    )}
                    <IconWithTooltip
                        skin="primary"
                        icon={PriorityIcon.F11}
                        tooltip={getLocalizedText(texts.F11) + ' (F11)'}
                        active={
                            filtersButton && filtersButton.isSelected && filtersButton.isSelected()
                        }
                        onClick={filtersButton && filtersButton.action}
                    />
                    {extraMarkup}
                    <MenuIcon name="star-icon" item={favoritesButton} primarySkin />
                    <MenuIcon name="export-icon" item={excelButton} primarySkin />
                    {pageSettings.length > 0 && <PageSettings {...this.props} />}
                </div>
                <div className="buttons-row close-section">
                    <HeaderHelpButton tooltipPosition="bottom-end" />
                    <MenuIcon
                        name="close-icon"
                        item={closeButton}
                        tooltipPosition={tooltipPosition}
                        role={EXIT_FORM}
                        primarySkin
                    />
                </div>
            </section>
        );
    }
}

export const IconWithTooltip = withTooltip(Icon);
export const TopMenu = withUpdate(TopMenuComp);
